module.exports = {
	"arrow-left": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"d": "M11.81,22,2.16,12.09,11.81,2,13,3.11,5.16,11.28H21.84v1.6H5.18l7.78,8Z"
			}
		]
	},
	"arrow-right": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"d": "M12.19,22l9.65-9.91L12.19,2,11,3.11l7.81,8.17H2.16v1.6H18.82l-7.78,8Z"
			}
		]
	},
	"arrow-up": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"d": "M21.24,12.48l-8.71-8.48V22h-1.07V3.99l-8.71,8.48L2,11.74L12,2l10,9.74L21.24,12.48z"
			}
		]
	},
	"calendar": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"d": "M9.79,18.55a3.86,3.86,0,0,1-1.85-.45,3.72,3.72,0,0,1-1.78-3.38H7.59a2.45,2.45,0,0,0,1,2.13,2.82,2.82,0,0,0,2.67-.14,1.57,1.57,0,0,0,.78-1.45,1.55,1.55,0,0,0-.9-1.2,4.54,4.54,0,0,0-1.64-.28l-.65,0,0-1.42A5.68,5.68,0,0,0,10.82,12a1.23,1.23,0,0,0,.76-.93,1.48,1.48,0,0,0-1.22-1.39,2.09,2.09,0,0,0-2.53,1,2.36,2.36,0,0,0-.11.87H6.29a3.54,3.54,0,0,1,.21-1.4,3.51,3.51,0,0,1,4.24-1.83A2.84,2.84,0,0,1,13,11.14a2.43,2.43,0,0,1-1,1.76,2.83,2.83,0,0,1,1.48,2.26,3,3,0,0,1-1.44,2.75A4.19,4.19,0,0,1,9.79,18.55Zm8-10.09H16.32v0a1.8,1.8,0,0,1-.46,1.33,2,2,0,0,1-1.25.47h-.17v1.43h1.88v6.49h1.43ZM22,2H2V22H22ZM3.43,6.08H20.57V20.57H3.43Zm0-2.65H20.57V4.66H3.43Z"
			}
		]
	},
	"caret-down": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"d": "M12,17.79,2,7.64,3.41,6.21,12,14.93l8.56-8.65L22,7.7Z"
			}
		]
	},
	"caret-left-bold": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"d": "M15.85,22l-10-10L15.91,2l2.23,2.23L10.33,12l7.75,7.74Z"
			}
		]
	},
	"caret-left": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"d": "M16.18,22l-10-10,10-10,1.55,1.54L9.3,12l8.43,8.43Z"
			}
		]
	},
	"caret-right-bold": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"d": "M8.15,22l10-10L8.09,2,5.86,4.23,13.67,12,5.92,19.77Z"
			}
		]
	},
	"caret-right": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"d": "M7.82,22,6.27,20.46,14.7,12,6.21,3.54,7.76,2l10,10Z"
			}
		]
	},
	"checkmark": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"d": "M8.94,19.23,2,12.29l1.41-1.4,5.53,5.53L20.59,4.77,22,6.18Z"
			}
		]
	},
	"close": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"d": "M13,12l9,9-1,1-9-9L3,22,2,21l9-9L2,3,3,2l9,9,9-9,1,1Z"
			}
		]
	},
	"collapse": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"d": "M22,13.5H2v-3H22Z"
			}
		]
	},
	"expand": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"d": "M22,13.43H13.43V22H10.57V13.43H2V10.57h8.57V2h2.86v8.57H22Z"
			}
		]
	},
	"info-white": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"class": "st0",
				"d": "M12,23C5.9,23,1,18.1,1,12C1,5.9,5.9,1,12,1c6.1,0,11,4.9,11,11C23,18.1,18.1,23,12,23z M12,2.6\n\t\t\tc-5.2,0-9.4,4.2-9.4,9.4c0,5.2,4.2,9.4,9.4,9.4c5.2,0,9.4-4.2,9.4-9.4C21.4,6.8,17.2,2.6,12,2.6z"
			}
		],
		"rect": [
			{
				"x": "10.7",
				"y": "10.8",
				"class": "st0",
				"width": "2.5",
				"height": "8.2"
			},
			{
				"x": "10.7",
				"y": "5.8",
				"class": "st0",
				"width": "2.5",
				"height": "2.2"
			}
		]
	},
	"info": {
		"viewBox": "0 0 24 24",
		"paths": [
			{
				"d": "M12,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22ZM12,3.43A8.57,8.57,0,1,0,20.57,12,8.59,8.59,0,0,0,12,3.43Zm1.2,7.4H10.8v7.89h2.4Zm0-4.78H10.8V8.16h2.4Z"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/@vds/icons/~/@vds-core/icons/dist/cjs/Icon/data.json
// module id = 639
// module chunks = 0